import { IRootState } from "../../../redux/root.reducer";

export const ITEMS_PER_PAGE_ALL = -1;

export const selectChangeLogFiltersAndPagination = (state: IRootState) => {
    const { itemsPerPage, currentPage } = state.changeLog.pagination;

    return {
        query: state.changeLog.searchQuery,
        limit: itemsPerPage === ITEMS_PER_PAGE_ALL ? undefined : itemsPerPage,
        offset:
            itemsPerPage === ITEMS_PER_PAGE_ALL
                ? 0
                : (currentPage - 1) * itemsPerPage,
        sortField: state.changeLog.sorting.column,
        sortDirection: state.changeLog.sorting.order,
    };
};
